import styled from "@emotion/styled";
import type { JsonFormsCore } from "@jsonforms/core";
import { materialCells, materialRenderers } from "@jsonforms/material-renderers";
import { JsonForms } from "@jsonforms/react";
import { debounce } from "es-toolkit";
import { useEffect, useMemo } from "react";

import { JsonColorPicker, JsonFileDropzone, jsonColorPickerTester, jsonFileDropzoneTester } from "./controls";

type JsonFormState = Pick<JsonFormsCore, "data" | "errors">;
type JsonFormProps = Pick<Parameters<typeof JsonForms>[0], "data" | "uischema" | "schema" | "onChange">;

const DEBOUNCE_WAIT_TIME = 500;

// todo: example of customization to use special fields as matched by the "format" specifier in json schema
//       styling needs to be improved before use

const renderers = [
  ...materialRenderers,
  {
    tester: jsonColorPickerTester,
    renderer: JsonColorPicker,
  },
  {
    tester: jsonFileDropzoneTester,
    renderer: JsonFileDropzone,
  },
];

const StyledForm = styled.div`
  & span.MuiTypography-root.MuiCardHeader-title {
    font-weight: bold;
    font-size: 1.5rem;
  }

  & div.MuiFormControl-root {
    margin: 8px 0;
  }

  & div.MuiInput-root {
    max-width: 100%;
  }
`;

export const JsonForm = (props: JsonFormProps) => {
  const { onChange } = props;

  const debouncedOnChange = useMemo(
    () => debounce((state: JsonFormState) => onChange?.(state), DEBOUNCE_WAIT_TIME, { edges: ["trailing"] }),
    [onChange],
  );

  useEffect(() => () => debouncedOnChange?.flush(), [debouncedOnChange]);

  return (
    <StyledForm>
      <JsonForms {...{ ...props, cells: materialCells, renderers, onChange: debouncedOnChange }} />
    </StyledForm>
  );
};
